import ScrollReveal from '@/components/base/ScrollReveal';
import { img, readdy } from '@/utils/images';
import { getSiteConfig } from '@/utils/siteConfigStore';

export default function MapSection() {
  const { mapInfo } = getSiteConfig();

  return (
    <section className="relative bg-white py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">

          <ScrollReveal variant="fade-up">
            <div className="text-center mb-10">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">来访指引</p>
              <h2 className="text-2xl md:text-3xl font-bold text-brand-deep leading-tight">
                欢迎莅临总部参观考察
              </h2>
              <p className="text-gray-400 text-sm mt-2">
                前往前请提前预约，我们将安排专人接待
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal variant="scale-up" delay={100}>
            <div className="rounded-2xl overflow-hidden border border-brand-light/30 h-[280px] md:h-[380px]">
              <img
                src={img('readdy/7936d4133177e28c4099bd69d2972dfc.png')}
                alt="麦杰集团总部位置 - 西安市未央区"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="mt-6 bg-[#fafaf8] rounded-2xl p-6 md:p-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-brand-brown/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-2-fill text-brand-brown text-lg" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-medium uppercase tracking-wider mb-1">总部地址</p>
                    <p className="text-sm text-brand-deep font-medium leading-relaxed">{mapInfo.address}</p>
                    <a
                      href="https://map.baidu.com/search/西安市未央区未央路武警小区南楼"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="whitespace-nowrap inline-flex items-center gap-1 text-brand-brown text-xs mt-1.5 hover:underline transition cursor-pointer"
                    >
                      <i className="ri-external-link-line"></i>
                      在百度地图中查看
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-brand-brown/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-brand-brown text-lg" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-medium uppercase tracking-wider mb-1">营业时间</p>
                    <p className="text-sm text-brand-deep font-medium leading-relaxed">{mapInfo.workingHours}</p>
                    <p className="text-xs text-gray-400 mt-1">法定节假日营业时间可能调整</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-brand-brown/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-brand-brown text-lg" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-medium uppercase tracking-wider mb-1">联系电话</p>
                    <a
                      href={`tel:${mapInfo.phone}`}
                      className="text-sm text-brand-deep font-medium leading-relaxed hover:text-brand-brown transition-colors cursor-pointer"
                    >
                      {mapInfo.phone}
                    </a>
                    <p className="text-xs text-gray-400 mt-1">欢迎来电咨询，我们将竭诚为您服务</p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>

        </div>
      </div>
    </section>
  );
}